import React, { useState, useEffect } from 'react';
import { Bell, MessageCircle, Heart, X, CheckCircle } from 'lucide-react';

const NotificationPopup = ({ notifications, onClose }) => {
  const [visible, setVisible] = useState([]);

  useEffect(() => {
    if (notifications.length === 0) return;
    const derniere = notifications[0];
    setVisible(prev => {
      if (prev.find(n => n.id === derniere.id)) return prev;
      return [...prev, { ...derniere, show: true }];
    });
    const timer = setTimeout(() => {
      setVisible(prev => prev.map(n =>
        n.id === derniere.id ? { ...n, show: false } : n
      ));
      setTimeout(() => {
        setVisible(prev => prev.filter(n => n.id !== derniere.id));
        onClose(derniere.id);
      }, 300);
    }, 5000);
    return () => clearTimeout(timer);
  }, [notifications, onClose]);

  const fermer = (id) => {
    setVisible(prev => prev.map(n =>
      n.id === id ? { ...n, show: false } : n
    ));
    setTimeout(() => {
      setVisible(prev => prev.filter(n => n.id !== id));
      onClose(id);
    }, 300);
  };

  const getIcon = (type) => {
    switch (type) {
      case 'message': return <MessageCircle size={20} style={{ color: '#F5A623' }} />;
      case 'favori': return <Heart size={20} className="text-red-400" />;
      case 'alerte': return <Bell size={20} style={{ color: '#F5A623' }} />;
      default: return <CheckCircle size={20} className="text-green-400" />;
    }
  };

  if (visible.length === 0) return null;

  return (
    <div className="fixed bottom-4 right-4 z-50 space-y-3">
      <style>{`
        @keyframes progressBar { from { width: 100%; } to { width: 0%; } }
        .progress-bar { animation: progressBar 5s linear forwards; }
      `}</style>
      {visible.map(notif => (
        <div
          key={notif.id}
          style={{
            background: '#111',
            border: '1px solid #333',
            transform: notif.show ? 'translateX(0)' : 'translateX(120%)',
            opacity: notif.show ? 1 : 0,
            transition: 'all 0.3s ease',
            maxWidth: '320px',
            position: 'relative',
            overflow: 'hidden'
          }}
          className="rounded-2xl shadow-2xl p-4 flex items-start gap-3"
        >
          <div style={{ background: '#F5A62320' }} className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0">
            {getIcon(notif.type)}
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-white text-sm font-bold">{notif.titre}</p>
            <p className="text-gray-400 text-xs mt-0.5">{notif.message}</p>
            {notif.lien && (
              <a href={notif.lien} style={{ color: '#F5A623' }} className="text-xs font-semibold mt-1 inline-block hover:opacity-80">
                Voir →
              </a>
            )}
          </div>
          <button onClick={() => fermer(notif.id)} className="text-gray-500 hover:text-gray-300 transition flex-shrink-0">
            <X size={16} />
          </button>
          <div className="progress-bar" style={{ position: 'absolute', bottom: 0, left: 0, height: '3px', background: '#F5A623' }} />
        </div>
      ))}
    </div>
  );
};

export default NotificationPopup;